// extracted by mini-css-extract-plugin
export default {"large":"button_large__tjyIe","medium":"button_medium__d7FwM","small":"button_small__h5j9d","primary":"button_primary__ORBqv","secondary":"button_secondary__B668O"};